import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ce3557e&scoped=true"
import script from "./index.vue?vue&type=script&route=%2Frouter_manage%2Fedit%2Fapp_router_manage&lang=js"
export * from "./index.vue?vue&type=script&route=%2Frouter_manage%2Fedit%2Fapp_router_manage&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ce3557e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce3557e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VRow,VSwitch})
